/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MinimalEdition } from './MinimalEdition';
import {
    MinimalEditionFromJSON,
    MinimalEditionFromJSONTyped,
    MinimalEditionToJSON,
} from './MinimalEdition';
import type { MinimalSupportUser } from './MinimalSupportUser';
import {
    MinimalSupportUserFromJSON,
    MinimalSupportUserFromJSONTyped,
    MinimalSupportUserToJSON,
} from './MinimalSupportUser';
import type { MinimalTenant } from './MinimalTenant';
import {
    MinimalTenantFromJSON,
    MinimalTenantFromJSONTyped,
    MinimalTenantToJSON,
} from './MinimalTenant';
import type { Region } from './Region';
import {
    RegionFromJSON,
    RegionFromJSONTyped,
    RegionToJSON,
} from './Region';
import type { Role } from './Role';
import {
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';

/**
 * 
 * @export
 * @interface SupportGroup
 */
export interface SupportGroup {
    /**
     * 
     * @type {string}
     * @memberof SupportGroup
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof SupportGroup
     */
    name: string;
    /**
     * 
     * @type {Array<MinimalSupportUser>}
     * @memberof SupportGroup
     */
    supportUsers: Array<MinimalSupportUser>;
    /**
     * 
     * @type {Array<MinimalTenant>}
     * @memberof SupportGroup
     */
    readonly tenants: Array<MinimalTenant>;
    /**
     * 
     * @type {Array<Region>}
     * @memberof SupportGroup
     */
    regions?: Array<Region> | null;
    /**
     * 
     * @type {Array<MinimalEdition>}
     * @memberof SupportGroup
     */
    readonly editions: Array<MinimalEdition>;
    /**
     * 
     * @type {Role}
     * @memberof SupportGroup
     */
    readonly role: Role;
}

/**
 * Check if a given object implements the SupportGroup interface.
 */
export function instanceOfSupportGroup(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "supportUsers" in value;
    isInstance = isInstance && "tenants" in value;
    isInstance = isInstance && "editions" in value;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function SupportGroupFromJSON(json: any): SupportGroup {
    return SupportGroupFromJSONTyped(json, false);
}

export function SupportGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'supportUsers': ((json['support_users'] as Array<any>).map(MinimalSupportUserFromJSON)),
        'tenants': ((json['tenants'] as Array<any>).map(MinimalTenantFromJSON)),
        'regions': !exists(json, 'regions') ? undefined : (json['regions'] === null ? null : (json['regions'] as Array<any>).map(RegionFromJSON)),
        'editions': ((json['editions'] as Array<any>).map(MinimalEditionFromJSON)),
        'role': RoleFromJSON(json['role']),
    };
}

export function SupportGroupToJSON(value?: SupportGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'support_users': ((value.supportUsers as Array<any>).map(MinimalSupportUserToJSON)),
        'regions': value.regions === undefined ? undefined : (value.regions === null ? null : (value.regions as Array<any>).map(RegionToJSON)),
    };
}

